import React from 'react'
import LeftSideBar from '../../components/LeftSideBar';
import Title from '../../components/Title';
import InquiryForm from '../InquiryForm';
import Blog_Section from '../../components/home/BlogSection';

export const Sole_Proprietorship = () => {
    return (
        <div className='services_main_wrapper'>
            <div className='container'>
                <div className='row mt-5 mb-5'>
                    <div className='col-md-3'>
                        <LeftSideBar />
                    </div>
                    <div className='col-md-9'>
                        <div className='right_side_content'>
                            <div className='section_main_title d-flex align-items-center justify-content-between'>
                                <div className='title_and_icon d-flex align-items-center'>
                                    <img src='/images/sole-proprietorship_icon.jpg'></img>
                                    <Title text="Sole Proprietorship " className="custom-heading" />
                                </div>
                            </div>
                            <div className='discriptions'>
                                <p>A sole proprietorship is a very popular type of business entity, particularly in the unorganized sector,
                                    mainly among small traders and merchants. At Vanani & Associates, we offer comprehensive services to help
                                    you establish and manage your sole proprietorship efficiently. With minimal compliance requirements and
                                    complete control over your business operations, a sole proprietorship is a great option for small businesses
                                    looking for a simple and cost-effective structure.</p>
                            </div>
                            <div className='number_list_wrap'>
                                <h4 class="mb-2 font-weight-600">Why Choose a Sole <sapn class="key_features">Proprietorship?</sapn></h4>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <ol className='mt-2 img_box_design d-flex p-0 text-center gap-3'>
                                            <li className='mb-1 w-25'>
                                                <img src='/images/Easy-to-Start.jpg' width='55' alt='Easy to Start'></img>
                                                <strong>Easy to Start</strong>
                                                <p className=''>Minimal registration formalities make it easy to set up a sole proprietorship.</p>
                                            </li>
                                            <li className='mb-1 w-25'>
                                                <img src='/images/Complete-Control.jpg' width='55' alt='Complete Control'></img>
                                                <strong>Complete Control</strong>
                                                <p>Full control over business decisions as the sole owner.</p>
                                            </li>
                                            <li className='mb-1 w-25'>
                                                <img src='/images/Minimal-Compliance.jpg' width='55' alt='Minimal Compliance'></img>
                                                <strong>Minimal Compliance</strong>
                                                <p>Fewer regulatory requirements for easier management.</p>
                                            </li>
                                            <li className='mb-1 w-25'>
                                                <img src='/images/Cost-Effective.jpg' width='65' alt='Cost-Effective'></img>
                                                <strong>Cost Effective</strong>
                                                <p>Lower setup and operating costs compared to other business structures.</p>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                            <div className='check_list_wrap mt-2 icon_img'>
                                <ul className='row'>
                                    <h4 class="mb-3 font-weight-600">Advantages of a <sapn class="key_features">Sole Proprietorship</sapn></h4>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/compliant.png' width="55"></img>
                                                <p><strong>Lower Compliance</strong>Compliance requirements are typically limited to personal tax filings and business-specific licenses or registrations.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/registration.png' width="55"></img>
                                                <p><strong>Easy Registration</strong>Sole proprietorships do not require formal incorporation, making the registration process quick and hassle-free.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/Simplicity.png' width="55"></img>
                                                <p><strong>Simplicity</strong>With no partners or shareholders, the business operations are simplified, allowing for quick decision-making.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/lower-taxes.png' width="55"></img>
                                                <p><strong>Lower Taxes</strong>Thanks to minimal compliance formalities, sole proprietorships are inexpensive to set up and maintain, even in the long run.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/completed-control.png' width="55"></img>
                                                <p><strong>Complete Control</strong>You have absolute control over all aspects of your business, including finances, operations, and growth strategies.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/reduction.png' width="55"></img>
                                                <p><strong>Reduced Costs</strong>Thanks to minimal compliance formalities, sole proprietorships are inexpensive to set up and maintain, even in the long run.</p>
                                            </div>
                                        </li>
                                    </div>
                                </ul>
                            </div>

                            <div className='main_back_clr mt-5'>
                                <div className='col-md-12'>
                                    <div className='check_list_wrap mt-2'>
                                        <h4 class="mb-3 font-weight-600">Disadvantages of a <sapn class="key_features">Sole Proprietorship</sapn></h4>
                                        <ul>
                                            <li><strong>Unlimited Liability:</strong>As the sole owner, you are personally liable for all business debts and obligations, which can put your personal assets at risk.</li>
                                            <li><strong>Limited Fundraising Options:</strong>Sole proprietorships often rely on personal savings and loans, making it challenging to raise capital from investors.</li>
                                            <li><strong>Lack of Continuity: </strong>The business’s existence is tied to the owner’s life, and it may dissolve upon the owner’s death or incapacity.</li>
                                            <li><strong>Limited Growth Potential: </strong>The structure is best suited for small-scale operations and may not be ideal for businesses seeking significant expansion.</li>
                                            <li><strong>Unincorporated Business: </strong>Sole proprietorships are not incorporated, and there is no centralized database to check if they are active or inactive, leading to their classification as unorganized businesses.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className='check_list_wrap mt-4 count_box'>
                                <h4 class="mb-3 pb-2 pt-3 font-weight-600">Documents<sapn class="key_features"> Required</sapn></h4>
                                <ul>
                                    <div className='row'>
                                        <div class="col-md-4">
                                            <li><strong>Address Proof and Identity Proof (PAN Card):</strong>Essential for all registrations and compliance.</li>
                                        </div>
                                        <div class="col-md-4">
                                            <li><strong>KYC Documents:</strong>Required for various registrations and banking purposes.</li>
                                        </div>
                                        <div class="col-md-4">
                                            <li><strong>Rental Agreement or Sale Deed: </strong>Proof of business address.</li>
                                        </div>
                                    </div>
                                </ul>
                            </div>

                            <div className='number_list_wrap img-with-check mt-4'>
                                <h4 class="mb-2 pb-2 pt-2 font-weight-600">Our<sapn class="key_features"> Services </sapn>Include</h4>
                                <ol className='row'>
                                    <div className='col-md-6'>
                                        <div className='left_side_img'>
                                            <img src='images/compliance-left.jpg' className='img_width img-width'></img>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <li className='mt-3 md-mt-0 p-0'><h5> Registration and Compliance</h5>
                                            <ul className='mt-2'>
                                                <li><strong>GST Registration</strong>We help you obtain GST registration to ensure compliance with tax regulations.</li>
                                                <li><strong>Professional Tax (PTEC)</strong>Assistance with professional tax registration for your proprietorship.</li>
                                                <li><strong>MSME (UDYAM)</strong>Register your business as a Micro, Small, and Medium Enterprise to avail various government benefits.</li>
                                                <li><strong>Shop & Establishment Certificate (GUMSTA)</strong>Obtain necessary licenses to comply with local business regulations.</li>
                                                <li><strong>Additional Registrations</strong>We provide support for additional registrations such as Trademark, Importer Exporter Code (IEC), PTRC, PF, ESIC, and MLWF.</li>
                                            </ul>
                                        </li>
                                    </div>
                                    <div className='col-md-6 back_clr'>
                                        <li className='mt-3 p-0'><h5>Ongoing Compliance Support</h5>
                                            <ul className='mt-2'>
                                                <li><strong>Personal Income Tax Filing</strong>Help with filing personal income tax returns using ITR-3 or ITR-4.</li>
                                                <li><strong>GST Returns </strong>Assistance with filing GST returns monthly or quarterly.</li>
                                                <li><strong>TDS Filings </strong>Support in quarterly TDS filings and other compliance requirements.</li>
                                            </ul>
                                        </li>
                                    </div>
                                    <div className='col-md-6 back_clr'>
                                        <li className='mt-3 p-0'><h5>Bank Account Setup</h5>
                                            <ul className='mt-2'>
                                                <li><strong>Account Opening Support</strong> Assistance in opening a current bank account using the proprietor’s PAN card and business proof documents.</li>
                                            </ul>
                                        </li>
                                    </div>
                                </ol>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* <Blog_Section/> */}
            <InquiryForm />
        </div>
    )
}

export default Sole_Proprietorship;
